import { render, staticRenderFns } from "./SavedLocations.vue?vue&type=template&id=5965f180&scoped=true&lang=pug"
import script from "./SavedLocations.vue?vue&type=script&lang=js"
export * from "./SavedLocations.vue?vue&type=script&lang=js"
import style0 from "./SavedLocations.vue?vue&type=style&index=0&id=5965f180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5965f180",
  null
  
)

export default component.exports